import { Component, OnInit, ɵConsole } from '@angular/core';
import { NgbDateStruct, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { OmsServiceService } from '../services/oms-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedService } from '../../../../tools/src/lib/shared/shared.service';
import { ConstantsService } from '../services/constants.service';
import { FormGroup, FormControl, FormsModule, Validators } from '@angular/forms';
//import * as data from './data.';
import { ReportDetailsComponent } from '../modal-popups/report-details/report-details.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";
import { NgbDate, NgbCalendar, NgbDateParserFormatter, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { configurton } from '../../assets/data/configuration';
//import { UploadReportComponent } from '../modal-popups/upload-report/upload-report.component';
import { TrackOrderComponent } from '../modal-popups/track-order/track-order.component';
import { TrackReimbursementComponent } from '../modal-popups/track-reimbursement/track-reimbursement.component';
import { DatePipe, JsonPipe } from '@angular/common';

@Component({
  selector: 'app-reimbursement-list',
  templateUrl: './reimbursement-list.component.html',
  styleUrls: ['./reimbursement-list.component.scss']
})
export class ReimbursementListComponent implements OnInit {
  reimbursRequest = {};
  reimbursListRes = [];
  page = 1;
  pageSize = 20;
  collectionSize = 0;
  datacount = 0;
  totalRecords: Number = 0;
  bsRangeValue: Date[];
  maxDate = new Date();
  currentDate = new Date();
  searchForm: FormGroup;
  selectedFromDate: any;
  selectedToDate: any;
  searchFormRequest = {};
  reimbursementStatusList: [];
  fromDate: any;
  toDate: NgbDate | null;
  businessOptions = [
    { label: 'Consultation', value: '1' },
    { label: 'Medicine', value: '2' },
    { label: 'Pathology', value: '3' },
    { label: 'Radiology', value: '4' },
  ];

  constructor(
    private omsServiceService: OmsServiceService,
    private _router: Router,
    private sharedService: SharedService,
    private _activatedRoute: ActivatedRoute,
    private constantsService: ConstantsService,
    private modalService: NgbModal,
    private SpinnerService: NgxSpinnerService,
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
  ) {

    this.searchForm = new FormGroup({
      searchBy: new FormControl(),
      searchByValue: new FormControl(),
      startDate: new FormControl("", [Validators.required]),
      endDate: new FormControl("", [Validators.required]),
      status: new FormControl(),
      businessId: new FormControl(),

    });
    this.currentDate = new Date()
    this.maxDate.setDate(this.maxDate.getDate() + 7);
    this.bsRangeValue = [this.currentDate, this.maxDate];
    console.log(`this.currentDate,this.maxDate`, this.currentDate, this.maxDate);
  }

  ngOnInit(): void {
    this.sharedService.headerData.subscribe(val => {
      console.log('get reimbursment data =' + val)
      this.getReimbursData(1);
      this.getStatusList()
    });
  }

  getReimbursData(page) {
    this.page = page
    this.SpinnerService.show();
    // this.reimbursRequest['tenantCode'] = '1000001';
    // this.reimbursRequest['orgCode'] = '100001';
    this.reimbursRequest['tenantCode'] = '1000248';
    this.reimbursRequest['orgCode'] = '100337';
    if (this.pageSize != 0 && this.page != 0) {
      this.reimbursRequest["sortBy"] = this.constantsService.SORT_BY;
      this.reimbursRequest["limit"] = this.pageSize;
      this.reimbursRequest["skip"] = this.pageSize * (this.page - 1);
    }
    let fromDate = this.currentDate
    let selectedFromDate;
    let selectedToDate;
 
    if (fromDate != null && fromDate != undefined) {
      let fromDateValue = fromDate.getFullYear() + "-" + (fromDate.getMonth() + 1) + "-" + fromDate.getDate();
      selectedFromDate = this.sharedService.getStringDate(new Date(fromDateValue));
    } else {
      let fromDateValue = new Date().getFullYear() + "-" + (new Date().getMonth() - 2) + "-" + new Date().getDate();
    }
    // let toDate = this.toDate;
    let toDate = this.maxDate;
    if (toDate != null && toDate != undefined) {
      // let toDateValue = toDate.year + "-" + toDate.month + "-" + toDate.day;
      let toDateValue = toDate.getFullYear() + "-" + (toDate.getMonth() + 1) + "-" + toDate.getDate();
      selectedToDate = this.sharedService.getStringDate(new Date(toDateValue));
    } else {
 
      let toDateValue = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();
      ;
 
    }
    this.reimbursRequest["fromDate"] = selectedFromDate;
    this.reimbursRequest["toDate"] = selectedToDate;
 
    if (this.searchForm.get("searchByValue").value != null && this.searchForm.get("searchByValue").value != undefined) {
      if (this.searchForm.get("searchBy").value == "Transaction ID") {
        this.reimbursRequest["transactionId"] = this.searchForm.get("searchByValue").value;
      }
      else if (this.searchForm.get("searchBy").value == "Claim ID") {
        this.reimbursRequest["claimId"] = this.searchForm.get("searchByValue").value;
      }
 
    }
    if (this.searchForm.get("searchByValue").value == null && this.searchForm.get("searchByValue").value == undefined) {
      if (this.searchForm.get("status").value != 0 && this.searchForm.get("status").value != undefined) {
        this.reimbursRequest["status"] = this.searchForm.get("status").value;
      }
 
    }
 
    if (this.searchForm.get("businessId").value != null && this.searchForm.get("businessId").value != undefined) {
      this.reimbursRequest["business"] = this.searchForm.get("businessId").value;
    }
    this.omsServiceService.getReimbursementData(this.reimbursRequest).subscribe(
      (res) => {
        this.SpinnerService.hide();
        if (res["status"] == 1) {
          this.reimbursListRes = res["data"];
          this.datacount = res['total']
          console.log('reimbursListRes' + JSON.stringify(this.reimbursListRes))
        } else {
          this.SpinnerService.hide();
        }

      })
  }
  search(searchFormData, page = 1) {
    this.totalRecords = 0;
    this.reimbursListRes = [];
    this.SpinnerService.show();
    this.searchFormRequest = {};
    let fromDate = this.currentDate
    let selectedFromDate;
    let selectedToDate;

    if (fromDate != null && fromDate != undefined) {
      let fromDateValue = fromDate.getFullYear() + "-" + (fromDate.getMonth() + 1) + "-" + fromDate.getDate();
      selectedFromDate = this.sharedService.getStringDate(new Date(fromDateValue));
    } else {
      let fromDateValue = new Date().getFullYear() + "-" + (new Date().getMonth() - 2) + "-" + new Date().getDate();
    }
    // let toDate = this.toDate;
    let toDate = this.maxDate;
    if (toDate != null && toDate != undefined) {
      // let toDateValue = toDate.year + "-" + toDate.month + "-" + toDate.day;
      let toDateValue = toDate.getFullYear() + "-" + (toDate.getMonth() + 1) + "-" + toDate.getDate();
      selectedToDate = this.sharedService.getStringDate(new Date(toDateValue));
    } else {

      let toDateValue = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();
      ;

    }

    if (this.searchForm.get("searchByValue").value != null && this.searchForm.get("searchByValue").value != undefined) {
      if (this.searchForm.get("searchBy").value == "Transaction ID") {
        this.searchFormRequest["transactionId"] = this.searchForm.get("searchByValue").value;
      }
      else if (this.searchForm.get("searchBy").value == "Claim ID") {
        this.searchFormRequest["claimId"] = this.searchForm.get("searchByValue").value;
      }

    }
    //status search begins
    if (this.searchForm.get("searchByValue").value == null && this.searchForm.get("searchByValue").value == undefined) {
      if (searchFormData.controls.status.value != 0 && searchFormData.controls.status.value != undefined) {
        this.searchFormRequest["status"] = searchFormData.controls.status.value;
      }

    }

    if (this.pageSize != 0 && this.page != 0) {
      this.searchFormRequest["limit"] = this.pageSize;
      this.searchFormRequest["skip"] = 0;
    }

    if (this.searchForm.get("businessId").value != null && this.searchForm.get("businessId").value != undefined) {
      this.searchFormRequest["business"] = [this.searchForm.get("businessId").value];
    }

    // this.searchFormRequest['tenantCode'] = '1000001';
    // this.searchFormRequest['orgCode'] = '100001';
    this.searchFormRequest['tenantCode'] = '1000248';
    this.searchFormRequest['orgCode'] = '100337';
    this.searchFormRequest["fromDate"] = selectedFromDate;
    this.searchFormRequest["toDate"] = selectedToDate;

    this.omsServiceService.getReimbursementData(this.searchFormRequest).subscribe(
      (res) => {
        console.log(`res`, res);
        this.searchFormRequest = {};
        if (res["data"] != null) {
          this.reimbursListRes = res["data"];
          this.datacount = res['total']
          this.page =1;
        } else {
          this.datacount = 0;
        }
        this.SpinnerService.hide();
        
      })
    this.SpinnerService.hide();
  }
  getReimbursById(transId, claimId) {
    this.SpinnerService.hide();
    let sessionId;
    this.sharedService.sessionId.subscribe(val => {
      sessionId = val;

    });

    const url = this._router.createUrlTree(['/reimbursement-details/' + transId + '/' + claimId])
    // window.open(url.toString(), '_blank')
    var myWindow = window.open(url.toString(),transId)
    myWindow.focus();
  }
  opentrackReimbursementModal(transactionId, claimId) {
    //console.log(this.orderDetailsRes);
    const modalRef = this.modalService.open(TrackReimbursementComponent, { windowClass: 'commonStyleModals modalWidth90p' });
    const closeModelRef = modalRef.result.then(
      (res) => {

      }
    );
    modalRef.componentInstance.order_id = transactionId;
    modalRef.componentInstance.claim_id = claimId;

  }
  pageChange(currentPage) {
    console.log(`currentPage`, currentPage);
    // if (this.searchForm.get('status').value != 0 && this.searchForm.get('status').value != undefined) {
    //   let status = this.searchForm.get('status').value
    //   this.getReimbursData(status, currentPage, true);
    // }else{
    //   let selectedStatus;
    //   this.sharedService.headerSelectedStatus.subscribe(val => {
    //     selectedStatus = val;
    //   });
    //   this.getReimbursData(selectedStatus, currentPage, true);
    // }
    this.getReimbursData(currentPage);
  }
  clear() {
    this.searchForm.reset();
    this.currentDate = new Date()
    this.maxDate.setDate(this.maxDate.getDate() + 7);
    this.bsRangeValue = [this.currentDate, this.maxDate];
  }
  getStatusList() {
    let statusRequest = {};
    statusRequest["claimId"] = '12345';
    this.omsServiceService.getReimburseStatusList(statusRequest).subscribe(
      (res) => {
        this.reimbursementStatusList = res["data"]
      }
    )
  }
  onValueChange(value: Date): void {
    var data = value;
    this.currentDate = data[0]
    this.maxDate = data[1]
    console.log(`data`, this.currentDate);
  }
}
